import { useState, useCallback } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const usePostOpInstructionsValidation = (formData) => {
  const { showNotification } = useNotification();
  const [errors, setErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = "";
    switch (name) {
      case 'ward_no':
        if (!value) error = "Ward No is required";
        break;
      case 'room_no':
        if (!value) error = "Room No is required";
        break;
      case 'instruction_date':
        if (!value) error = "Instruction Date is required";
        break;
      case 'surgery_done':
        if (!value) error = "Surgery Done is required";
        break;
      case 'anaesthesiologist':
        if (!value) error = "Anaesthesiologist is required";
        break;
      case 'anaesthesia':
        if (!value) error = "Anaesthesia is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  }, []);

  const validateForm = useCallback(() => {
    const requiredFields = [
      { key: 'ward_no', label: 'Ward No.' },
      { key: 'room_no', label: 'Room No.' },
      { key: 'instruction_date', label: 'Instruction Date' },
      { key: 'surgery_done', label: 'Surgery Done' },
      { key: 'anaesthesiologist', label: 'Anaesthesiologist' },
      { key: 'anaesthesia', label: 'Anaesthesia Type' },
    ];

    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '') {
        tempErrors[key] = `${label} is required`;
      }
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { 
        el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        el.focus(); 
      }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }

    return Object.keys(tempErrors).length === 0;
  }, [formData, showNotification]);

  return { errors, setErrors, validateField, validateForm };
};
